export enum TourType {
  DOMESTIC_CULTURE = 'DomesticCulture',
  ABROAD = 'Abroad',
  CRUISE = 'Cruise',
}
